import { collectionPage } from './Reducers/CollectionPage.reducer';

export const pnCollectionPage = {
  collectionPage,
};
